import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { apiClientService, apiSpecialEvent } from "../../services/data";
import { Button } from "../../styles-components/Buttons";
import { Container } from "../../styles-components/Container";
import {
  Column,
  ErrorMessage,
  Form,
  FormHeader,
  Label,
  Row,
  RowOption,
} from "../../styles-components/FormItens";
import inputFormat from "../../utils/inputFormat";
import LoadingEffect from "../LoadingEffect";
import ToggleSwitch from "../ToggleSwitch";

const SpecialEventPropose = ({ id, setId, updateData, onClose, isFirst }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [services, setServices] = useState([]);
  const [hasAddition, setHasAddition] = useState(null);

  const {
    register,
    handleSubmit,
    reset,
    watch,
    unregister,
    formState: { errors },
  } = useForm();

  const watchIsOneNcm = watch("is_one_ncm");

  const fetchServices = async () => {
    await apiClientService.index(1).then((response) => {
      response.data.data.sort(function (a, b) {
        return a.service.nome > b.service.nome
          ? 1
          : b.service.nome > a.service.nome
          ? -1
          : 0;
      });
      setServices(response.data.data);
      setIsLoading(false);
    });
  };

  const fetchEvent = async (id) => {
    await apiSpecialEvent.show(id).then((response) => {
      setHasAddition(response.data.has_addition);
    });
  };

  const verifyDote = (value) => {
    return ""+value.indexOf(",") == -1;
  }

  const onSubmit = async (data) => {
    data.is_first_propose = isFirst;
    apiSpecialEvent
      .update(id, data)
      .then((response) => {
        if (response.data.data && response.data.data.error) {
          toast.error(response.data.data.message);
        } else {
          toast.success("Proposta efetuada com sucesso!");
          updateData();
          setId(0);
          onClose();
        }
      })
      .catch((error) =>
        toast.error(error.message, "Algo deu errado ao cadastrar a proposta!")
      );
  };

  useEffect(() => {
    if (id > 0) {
      setIsLoading(true);
      reset();
      fetchEvent(id);
      fetchServices();
    }
  }, [id]);

  useEffect(() => {
    watchIsOneNcm ? unregister("services_id") : unregister("service_id");
  }, [watchIsOneNcm]);

  return (
    <>
      {isLoading ? (
        <LoadingEffect />
      ) : (
        <Container>
          <Form method="POST" onSubmit={handleSubmit(onSubmit)}>
            <FormHeader>
              <h1>Efetuar proposta</h1>
            </FormHeader>
            <Column>
              <Row>
                <Label style={{ width: "30%" }} htmlFor="payment_term">
                  Prazo de pagamento:
                </Label>
                <input
                  type="date"
                  {...register("payment_term", {
                    required: { value: true, message: "Informe está data!" },
                  })}
                  style={errors.payment_term && { ...inputFormat }}
                />
              </Row>
              {errors.payment_term && (
                <ErrorMessage color="--red">
                  {errors.payment_term.message}
                </ErrorMessage>
              )}
            </Column>
            <Column>
              <Row>
                <Label style={{ width: "30%" }} htmlFor="confirm_deadline">
                  Prazo de confirmação:
                </Label>
                <input
                  type="date"
                  {...register("confirm_deadline", {
                    required: { value: true, message: "Informe está data!" },
                  })}
                  style={errors.confirm_deadline && { ...inputFormat }}
                />
              </Row>
              {errors.confirm_deadline && (
                <ErrorMessage color="--red">
                  {errors.confirm_deadline.message}
                </ErrorMessage>
              )}
            </Column>
            <Column>
              <ErrorMessage color="--blue-mustang">
                Informe os números decimais usando o ponto Ex: 11.99
              </ErrorMessage>
              <Row>
                <Label style={{ width: "30%" }} htmlFor="unitary_value">
                  Valor unitário:
                </Label>
                <input
                  type="float"
                  {...register("unitary_value", {
                    min: {
                      value: 1,
                      message: "Informe um valor maior que 0",
                    },
                    validate: {
                      withDote: v => verifyDote(v) || "Informe o valor com a ponto ao invés de vírgula"
                    }
                  })}
                  style={errors.unitary_value && { ...inputFormat }}
                />
              </Row>
              {errors.unitary_value && (
                <ErrorMessage color="--red">
                  {errors.unitary_value.message}
                </ErrorMessage>
              )}
            </Column>
            {hasAddition === 1 && (
              <Column>
                <Row>
                  <Label style={{ width: "30%" }} htmlFor="addition_value">
                    Valor adicional:
                  </Label>
                  <input
                    type="float"
                    {...register("addition_value", {
                      required: {
                        value: true,
                        message: "Informe o valor total!",
                      },
                      min: {
                        value: 1,
                        message: "Informe um valor maior que 0",
                      },
                      validate: {
                        withDote: v => verifyDote(v) || "Informe o valor com a ponto ao invés de vírgula"
                      }
                    })}
                    style={errors.addition_value && { ...inputFormat }}
                  />
                </Row>
                {errors.addition_value && (
                  <ErrorMessage color="--red">
                    {errors.addition_value.message}
                  </ErrorMessage>
                )}
              </Column>
            )}
            <Column>
              <Row>
                <Label style={{ width: "30%" }} htmlFor="total_value">
                  Valor total:
                </Label>
                <input
                  type="float"
                  {...register("total_value", {
                    required: {
                      value: true,
                      message: "Informe o valor total!",
                    },
                    min: { value: 1, message: "Informe um valor maior que 0" },
                    validate: {
                      withDote: v => verifyDote(v) || "Informe o valor com a ponto ao invés de vírgula"
                    }
                  })}
                  style={errors.total_value && { ...inputFormat }}
                />
              </Row>
              {errors.total_value && (
                <ErrorMessage color="--red">
                  {errors.total_value.message}
                </ErrorMessage>
              )}
            </Column>
            <RowOption>
              <ToggleSwitch register={register} name={"is_one_ncm"} checked={false} />
              <Label>Não possui possibilidade de escolha de NCM?</Label>
            </RowOption>
            <Column>
              {!watchIsOneNcm ? (
                <>
                  <Row>
                    <Label style={{ width: "auto" }}>
                      Selecione as NCM possivéis:
                    </Label>
                  </Row>
                  {services.map((service) => (
                    <RowOption key={service.id + service.service.nome}>
                      <Label
                        style={{
                          display: "flex",
                          alignItems: "center",
                          width: "auto",
                        }}
                      >
                        <input
                          {...register("services_id", {
                            required: {
                              value: true,
                              message: "Selecione uma (s) opção!",
                            },
                            setValueAs: (v) => parseInt(v),
                          })}
                          style={errors.services_id && { ...inputFormat }}
                          type="checkbox"
                          value={service.service.id}
                        />
                        {service.service.nome}
                      </Label>
                    </RowOption>
                  ))}
                  {errors.services_id && (
                    <ErrorMessage color="--red">
                      {errors.services_id.message}
                    </ErrorMessage>
                  )}
                </>
              ) : (
                <>
                  <Row>
                    <Label style={{ width: "auto" }}>Selecione a NCM:</Label>
                  </Row>
                  {services.map((service) => (
                    <RowOption key={service.id + service.service.nome}>
                      <Label
                        style={{
                          display: "flex",
                          alignItems: "center",
                          width: "auto",
                        }}
                      >
                        <input
                          {...register("service_id", {
                            required: {
                              value: true,
                              message: "Selecione uma opção!",
                            },
                            setValueAs: (v) => parseInt(v),
                          })}
                          style={errors.service_id && { ...inputFormat }}
                          type="radio"
                          value={service.service.id}
                        />
                        {service.service.nome}
                      </Label>
                    </RowOption>
                  ))}
                  {errors.service_id && (
                    <ErrorMessage color="--red">
                      {errors.service_id.message}
                    </ErrorMessage>
                  )}
                </>
              )}
            </Column>
            <Button color="--white" backgroundColor="--orange" align="flex-end">
              Criar
            </Button>
          </Form>
        </Container>
      )}
    </>
  );
};

export default SpecialEventPropose;
